<template>
  <b-col sm="12">
    <b-btn @click="loadPrev()">Cargar datos de inspección previa</b-btn>
    {{msj}}
  </b-col>
</template>

<script>
import FormComponentBase from './FormComponentBase'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'FormComponentPrevInspection',
  extends: FormComponentBase,
  /* components: {
    FormComponent: () => import('./FormComponent')
  }, */
  data () {
    return {
      msj: ''
    }
  },
  watch: {
    value: function (val) {
      this.$emit('valuechange', val)
    }
  },
  computed: {
    ...mapState({
      'currmodel': 'currmodel',
      'metadatax': 'metadata'
    })
  },
  methods: {
    ...mapActions([
      'get_db'
    ]),
    loadPrev2 () {
      var obj = this
      this.msj = ''
      var query = {}
      if (this.currmodel.identification && this.currmodel.identification.type &&
        this.currmodel.identification.type === 'plataforma') {
        var platform = null
        var instalation = null
        var talud = null
        if (this.currmodel.identification && this.currmodel.identification.platform) {
          platform = this.currmodel.identification.platform
        }
        if (this.currmodel.identification && this.currmodel.identification.instalation) {
          instalation = this.currmodel.identification.instalation
        }
        if (this.currmodel.identification && this.currmodel.identification.talud) {
          talud = this.currmodel.identification.talud
        }
        query = {
          startkey: [platform, instalation, talud, {}],
          endkey: [platform, instalation, talud],
          descending: true,
          limit: 1
        }
      } else {
        var flowline = null
        var progressive = null
        var side = null
        if (this.currmodel.identification && this.currmodel.identification.flowline) {
          flowline = this.currmodel.identification.flowline
        }
        if (this.currmodel.identification && this.currmodel.identification.progressive) {
          progressive = this.currmodel.identification.progressive
        }
        if (this.currmodel.identification && this.currmodel.identification.side_to_ddv) {
          side = this.currmodel.identification.side_to_ddv
        }
        if (!(flowline && progressive)) {
          this.msj = 'Debe ingresar flowline y progresiva'
          return
        }
        query = {
          startkey: [flowline, progressive, side, {}],
          endkey: [flowline, progressive, side],
          descending: true,
          limit: 1
        }
      }
      obj.get_db().then(function (db) {
        db.query('app/checklist', query).then(function (res) {
          if (res.rows && res.rows.length === 1 && res.rows[0].value) {
            var insp = res.rows[0].value
            if (insp.landslide) {
              if (insp.landslide.inspection_n) {
                insp.landslide.inspection_n++
              }
              insp.landslide.inspection_date = new Date().toJSON().slice(0, 10)
            }
            // console.log(insp)
            for (var i in insp) {
              if (i !== '_id' && i !== '_rev' && i !== 'ifrm' && i !== '_attachments' &&
                i !== 'image' && i !== 'esquema' && i !== 'synced' && i !== 'username' &&
                i !== 'supervisor_2' && i !== 'supervisor_3' && i !== 'supervisor_4' &&
                i !== 'obs_ot' && i !== 'feedback' && i !== 'chat') {
                obj.$emit('updatex', {
                  action: 'set',
                  target: i,
                  id: null,
                  object: insp[i]
                })
              }
            }
            obj.msj = 'Datos Cargados'
          } else {
            obj.msj = 'No se pudieron encontrar los datos de la inspección anterior'
          }
        })
      }).catch(function (err) {
        console.log(err)
      })
    },
    loadPrev () {
      var obj = this
      this.$dialog.confirm('¿Seguro que desea cargar los datos del registro anterior?', { okText: 'Cargar', cancelText: 'Cancelar' })
        .then(obj.loadPrev2).catch(function (err) {
          if (err) { console.log(err) }
        })
    }
  }
}
</script>
